import { render, staticRenderFns } from "./QScoreCardBaseshopRegistrations.vue?vue&type=template&id=4697acb4&scoped=true&"
import script from "./QScoreCardBaseshopRegistrations.vue?vue&type=script&lang=js&"
export * from "./QScoreCardBaseshopRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697acb4",
  null
  
)

export default component.exports